import { render, staticRenderFns } from "./order-list.vue?vue&type=template&id=3a50000f&scoped=true"
import script from "./order-list.vue?vue&type=script&lang=js"
export * from "./order-list.vue?vue&type=script&lang=js"
import style0 from "./order-list.vue?vue&type=style&index=0&id=3a50000f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50000f",
  null
  
)

export default component.exports